/** One page of an already loaded list. Page numbers start at 1. */

export function pageSlice(items, page, pageSize) {
  const list = Array.isArray(items) ? items : [];
  const size = pageSize > 0 ? pageSize : 10;
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / size));
  const current = Math.min(Math.max(page || 1, 1), totalPages);
  const start = (current - 1) * size;

  return {
    items: list.slice(start, start + size),
    total,
    page: current,
    pageSize: size,
    totalPages,
  };
}
